var React = require('react');

function Fire (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.907 19.25c-3.483-1.963-4.4-3.821-3.876-6.359.387-1.874 1.654-3.398 1.776-5.268.541.985.767 1.695.828 2.725 1.722-2.11 2.86-5.03 2.927-8.098 0 0 4.485 2.635 4.779 6.616.386-.82.58-2.124.194-2.968 1.159.844 7.938 8.341-.918 13.352 1.665-3.242.43-7.616-2.461-9.636.193.868-.146 4.108-1.425 5.532.355-2.379-.337-3.385-.337-3.385s-.237 1.333-1.158 2.679c-.84 1.229-1.424 2.533-.33 4.81z","fill":"currentColor"}));
}

Fire.defaultProps = {"width":"16","height":"21","viewBox":"0 0 16 21"};

module.exports = Fire;

Fire.default = Fire;
